/** Aligned with backend MAX_COUNTRIES_EXPORT (epidemiology + prevProj). */
export const MAX_COUNTRIES_EXPORT = 60;

/** Soft threshold above which the UI warns that export may take longer. */
export const EXPORT_DURATION_WARN_THRESHOLD = 10;
